import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './index.css';
import App from './App';
import './App.css';

// --- Global scroll-restoration hardening ---
if ('scrollRestoration' in window.history) {
  window.history.scrollRestoration = 'manual';
}

function scrollAppMainToTop() {
  const scroller =
    document.querySelector('.app-main') ||
    document.scrollingElement ||
    document.documentElement;
  scroller?.scrollTo?.({ top: 0, left: 0, behavior: 'auto' });
}

// When page is restored from BFCache (iOS Safari), ensure top
window.addEventListener('pageshow', (e) => {
  if (e.persisted) {
    requestAnimationFrame(() => {
      requestAnimationFrame(scrollAppMainToTop);
    });
  }
});


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);